import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProductIntroductionGallery from './ProductIntroductionGallery';
import ProductIntroductionLinkSwiper from './ProductIntroductionLinkSwiper';
import Config from '../config/config';
import './ProductIntroduction.css';

class ProductIntroduction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gallerySwiper: null,
      thumbnailSwiper: null,
    };

    this.galleryRef = this.galleryRef.bind(this);
    this.thumbRef = this.thumbRef.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.gallerySwiper && nextState.thumbnailSwiper) {
      const { gallerySwiper, thumbnailSwiper } = nextState;

      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }

  galleryRef(ref) {
    if (ref) this.setState({ gallerySwiper: ref.swiper });
    if (ref === null) this.setState({ gallerySwiper: null });
  }

  thumbRef(ref) {
    if (ref) this.setState({ thumbnailSwiper: ref.swiper });
    if (ref === null) this.setState({ thumbnailSwiper: null });
  }

  render() {
    const { product, products, children } = this.props;

    let renderSingleImage;
    if (!product) {
      return <div className="product__loading" />;
    }
    if (product.image.length === 0) {
      renderSingleImage = (
        <figure className="image is-square">
          <div
            style={{ backgroundImage: "url('https://bulma.io/images/placeholders/128x128.png')" }}
            className="slide-product-image"
            alt={product.name}
          />
        </figure>
      );
    }
    if (product.image.length === 1) {
      renderSingleImage = (
        <figure className="image is-square">
          <div
            style={{ backgroundImage: `url(${Config.apiUrl}${product.image[0].url})` }}
            className="slide-product-image"
          />
        </figure>
      );
    }

    return (
      <div className=" product-introduction">
        <div className="columns">
          <div className="column is-three-fifths column--swiper">
            {product.image.length > 1 && <ProductIntroductionGallery product={product} />}
            {product.image.length <= 1 && renderSingleImage}
          </div>
          <div className="column is-two-fifths product-introduction-info">
            <div className="product-introduction-title">
              {product ? product.title : '資料讀取中...'}
            </div>
            <div className="product-introduction-title">
              {product ? product.chinese_title : '資料讀取中...'}
            </div>
            {children}
          </div>
        </div>
        {product.accessories && product.accessories.length > 0 && (
          <div className="accessories">
            <h1 className="title">產品配件</h1>
            <ProductIntroductionLinkSwiper
              products={products}
              dataArr={product.accessories}
              extraClass="swiper--accessories"
            />
          </div>
        )}
        {product.associations && product.associations.length > 0 && (
          <div className="suggestion">
            <h1 className="title">關聯商品</h1>
            <ProductIntroductionLinkSwiper
              products={products}
              dataArr={product.associations}
              extraClass="swiper--suggestion"
            />
          </div>
        )}
      </div>
    );
  }
}

ProductIntroduction.propTypes = {
  product: PropTypes.shape({
    image: PropTypes.arrayOf(PropTypes.object),
  }),
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
};

ProductIntroduction.defaultProps = {
  product: {
    image: [],
  },
};

export default ProductIntroduction;



// WEBPACK FOOTER //
// ./src/components/ProductIntroduction.js